export default "__VITE_ASSET__Q_hCuqp5__"